import React from "react";
import { Outlet, useLocation } from "react-router-dom";

/**
 * Renders the routed page inside a keyed wrapper so each SPA navigation
 * replays a light fade-in. The surrounding layout (header, sidebar, footer)
 * stays mounted — only the page content transitions.
 */
export default function FadeOutlet() {
  const location = useLocation();
  return (
    <div key={location.pathname} className="route-fade" data-testid="page-fade">
      <Outlet />
    </div>
  );
}
